import * as React from 'react';
import { connect } from 'react-redux';
import { Badge, Card, Image } from 'react-bootstrap';
import NotificationBadge from 'react-notification-badge';
import './PersonalInsurance.css';
import { setSelectedCover } from '../../actions/profileActions';
import { photoData } from '../../actions/cameraActions';
import { CHILLI_MONTHLY_RIGHT_ARROW } from '../../constants/copy';
import { navigateTo } from '../../actions/navigationActions';
import { showInEditRemoveScreen, showInEditScreen, showLegalScreen } from '../../actions/modalActions';
import { BLING_BRAND_NEW_PRODUCT_ID, BLING_LIKE_NEW_PRODUCT_ID, BLING_SCREEN_FIX_PRODUCT_ID, BUILDING_PRODUCT_ID, HOME_CONTENT_PRODUCT_ID, PERSONAL_SAFETY_PRODUCT_ID } from '../../constants/products';
import { toggleHasError, toggleSelfInspectPhotos } from '../../actions/selfInspectActions';
import { POLICY_COVER_ITEM } from '../../constants/constants';

class PersonalInsuranceCard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick(id) {
        // if this is a chilli car, reset the monthly mileage state
        await this.props.dispatchPhotoData({
            dashboardPhotoData: null,
            mileagePhotoData: null,
            step1RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
            step2RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
            step3RightImageUrl: CHILLI_MONTHLY_RIGHT_ARROW,
            step1Backround: "#fff",
            step2Backround: "#fff",
            step3Backround: "#fff",
            dashboardCanSubmit: true,
            photoData: null,
            photoAccepted: false,
            photoSubmitted: false,
            totalMileage: "",
            canSubmitMonthlyMileage: false,
        });

        if (this.props && this.props.sales && this.props.sales.isInEdit) {
            this.props.dispatchShowInEditScreen(id);
        }
        else if (this.props && this.props.sales && this.props.sales.isInRemove) {
            this.props.dispatchShowEditRemoveScreen(id);
        }
        else {
            await this.props.dispatchToggleHasError(false);
            await this.props.dispatchToggleSelfInspectPhotos(false);
            await this.props.dispatchSetSelectedCover(id);
            await this.props.onClickHandler(POLICY_COVER_ITEM);
        }
    }

    render() {
        let cardId = (this.props.profile.selectedPersonalCoverType === POLICY_COVER_ITEM && this.props.profile.selectedPersonalCover !== null) ? this.props.profile.selectedPersonalCover.id : "0";
        let productName =(this.props.productNumber === BUILDING_PRODUCT_ID) ? "Buildings" : ((this.props.productNumber === HOME_CONTENT_PRODUCT_ID) ? "Home contents" : ((this.props.productNumber === BLING_BRAND_NEW_PRODUCT_ID || this.props.productNumber === BLING_LIKE_NEW_PRODUCT_ID || this.props.productNumber === BLING_SCREEN_FIX_PRODUCT_ID) && this.props.profile.countryId === 157) ? "Cellphone" : this.props.headerText);
        let description = (this.props.productNumber === PERSONAL_SAFETY_PRODUCT_ID) ? "Personal safety assistance" : this.props.bodyText;
        const cover = this.props.profile.selectedPersonalPolicy.covers.filter(x => x.id === this.props.id);
        let coverName;
        if (cover[0] !== undefined) {
            if (cover[0].product === BLING_BRAND_NEW_PRODUCT_ID) {
                coverName = cover[0].riskItems[0].blingBrandNewCovers[0];
            }
            else if (cover[0].product === BLING_LIKE_NEW_PRODUCT_ID) {
                coverName = cover[0].riskItems[0].blingLikeNewCovers[0];
            }
            else if (cover[0].product === BLING_SCREEN_FIX_PRODUCT_ID) {
                coverName = cover[0].riskItems[0].blingScreenFixCovers[0];
            }
        }
        return (
            <>
                <div className="Personal-insurance-card" id="InsuranceCard">
                    <div className={(this.props.id === cardId ? 'isClicked ' : '') + " tile row noma"} onClick={() => this.handleClick(this.props.id)}>
                        {cover[0]?.riskItems[0]?.inspectionRequired &&
                            <div className="col-12 mb-10px nopa card-badge">
                                <Badge className="badge badge-pill"><p>Self-inspection required</p></Badge>
                            </div>
                        }
                        <div className="mr-20px">
                            <div className={this.props.image}></div>
                        </div>
                        <div className="col col-md-9 nopa">
                            <div className={productName === "Portable possessions" ? "row noma" : "row noma"}>
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="mb-6px line-height-normal font-weight-bold">{productName}
                                                {this.props.hasError &&
                                                    <Image className="warning-icon" title="" alt="" src="./images/warning-icon.svg" />
                                                }
                                            </p>
                                            {!this.props.hasError &&
                                                <div className="notifcationBadge text-right">
                                                    <NotificationBadge count={parseInt(this.props.alertCount)} />
                                                </div>
                                            }
                                        </div>
                                        <p className="coverAmounts font-size-16px line-height-normal mb-0px text-right">{this.props.profile.currencySymbol}{this.props.premium}</p>
                                    </div>
                                    <div>
                                        <p className="notification descriptionText nopa mb-2px line-height-normal">{description}</p>
                                        {(this.props.productNumber === BLING_BRAND_NEW_PRODUCT_ID || this.props.productNumber === BLING_LIKE_NEW_PRODUCT_ID || this.props.productNumber === BLING_SCREEN_FIX_PRODUCT_ID) &&
                                            <p className="notification descriptionText nopa mb-0px line-height-normal">Phone no: {coverName.cellPhoneNumber}</p>
                                        }

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        sales: state.sales
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowInEditScreen: (id, destination) => dispatch(showInEditScreen(id, destination)),
        dispatchShowEditRemoveScreen: (id, destination) => dispatch(showInEditRemoveScreen(id, destination)),
        dispatchSetSelectedCover: (id) => dispatch(setSelectedCover(id)),
        dispatchPhotoData: (data) => dispatch(photoData(data)),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchToggleSelfInspectPhotos: (value) => dispatch(toggleSelfInspectPhotos(value)),
        dispatchToggleHasError: (value) => dispatch(toggleHasError(value))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PersonalInsuranceCard);